module.exports = __webpack_public_path__ + "img/Pureshort_logo.3fd05b53.png";